/**
 * Core Adobe data layer functions and sitewide events, such as
 * `pageLoad`. Specific components may push their own events from
 * their related scripts (contact-form.js, modal-newsletter.js,
 * etc.) using functions exported from this module.
 */

import { userLookup } from './user-lookup';

/* Page data jQuery object (empty by default). *********************/
let $datalayer = jQuery([]);

/* Helper function for getting page data from $datalayer. **********/
const getPageData = (key) => {
  return $datalayer.length ? $datalayer.data(key) : null;
};

/* Helper function for preparing and sanitizing event data. ********/
const prepareEventData = (d) => {
  return d.replace(/\n/g, '').trim().toLowerCase();
};

/* Helper function for pushing and logging data layer events. ******/
const pushEvent = (event) => {
  window.adobeDataLayer = window.adobeDataLayer || [];
  window.adobeDataLayer.push(event);
  console.log('Data layer event:', JSON.stringify(event));
};

(($) => {
  $(() => {
    $datalayer = $('#datalayer');

    /* User data (for state/province value). ***********************/
    const user = userLookup();

    /* Default values for all events. ******************************/
    const country = 'CA';
    const state = user && user.province ? user.province.toUpperCase() : 'Unknown';
    const language = prepareEventData(getPageData('language'));

    /* event: 'pageLoad' *******************************************/
    window.addEventListener('load', () => {
      const event = {
        event: 'pageLoad',
        page: {
          name: prepareEventData(getPageData('page-name')),
          title: document.title,
          category: 'content',
        },
        attributes: {
          country,
          state,
          language,
        },
      };

      const pageSection = getPageData('page-section');

      if (pageSection) {
        event.page.section = prepareEventData(pageSection);
      }

      pushEvent(event);
    });

    /* event: 'video start' ****************************************/
    $('[data-video-src]').on('click', (e) => {
      const $target = $(e.currentTarget);
      const title = $target.attr('title');
      const text = $target.text();

      const event = {
        event: 'video start',
        attributes: {
          eventDetail: prepareEventData(title ? title : text),
        },
      };

      pushEvent(event);
    });

    /* event: 'anchor link click' **********************************/
    $('a[href^="#"]').on('click', (e) => {
      const $target = $(e.currentTarget);
      const text = $target.text();

      const clickEvent = {
        event: 'anchor link click',
        attributes: {
          eventDetail: prepareEventData(text),
          eventLocation: prepareEventData(getPageData('page-name')),
        },
      };

      pushEvent(clickEvent);
    });
  });
})(jQuery);

export { getPageData, prepareEventData, pushEvent };
